import { AxiosResponse } from "axios";
import { http } from "../../../utils";

export function fetchLedgerSummaryPdf(
    partyId?: string
) {
    let url = `/charts/pvt/ledger_summary_pdf_v2`
    if (partyId) {
        url = `${url}?party_id=${partyId}`
    }
    return http
        .get(
            url
        )
        .then((response: AxiosResponse) => response.data)
}

export function fetchLedgerSummaryExcel(
    partyId?: string
) {
    let url = `/charts/pvt/ledger_summary_excel_v2`
    if (partyId) {
        url = `${url}?party_id=${partyId}`
    }
    return http
        .get(
            url
        )
        .then((response: AxiosResponse) => response.data)
}